import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName } from '../utils'
import { loadCity, loadCourses, loadJuries, loadTalents } from '../utils/Network'
import { makeDarkSelectStyles } from './selectStyles';

export default function SelectJuries({ callback, value}) {

    const [SelectOptions, setSelectOptions] = useState([]);

    const customStyles = makeDarkSelectStyles({ width: '220px' });

    
    useEffect(() => {
        loadJuries(1, null, 1000).then(data => {
            if (data.results) {
                var juries = data.results;
                var temp = []
                var temp_options = []

                juries.map((item, i) => {
                    //var t = userTalents.find(x => x.talent.id === item.id)

                    temp.push(item)

                    var option = null;

                   
                        option = {
                            label:
                                item.first_name + " " + item.last_name ,
                                value: item.user
                        }

                    temp_options.push(option)

                })
                //
                setSelectOptions(temp_options);
                // callback()
                //setTalents(temp)
            }

        })
    }, [])

    const handleSelect = (e) => {
        callback(e && e.value,"jury")
    }

    return (
        <>
            <div className="filter-select">
                <Select
                    options={SelectOptions}
                    styles={customStyles}
                    onChange={handleSelect}
                    isClearable={true}
                    placeholder="Juries"
                    value={SelectOptions && SelectOptions.filter(obj => obj.value == value)}

                />
            </div>
            
        </>
    )
}
